export const AdminLogLevelType = {
	info: 0,
	warn: 1,
	error: 2,
	unhandled_error: 3,
	critical_error: 4,
}